/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type StepsListUpdateStepMutationVariables = {|
  id: string,
  ordered: number,
|};
export type StepsListUpdateStepMutationResponse = {|
  +recipeStepUpdate: ?{|
    +recipeStep: ?{|
      +id: string,
      +description: string,
      +ordered: number,
    |}
  |}
|};
export type StepsListUpdateStepMutation = {|
  variables: StepsListUpdateStepMutationVariables,
  response: StepsListUpdateStepMutationResponse,
|};
*/


/*
mutation StepsListUpdateStepMutation(
  $id: ID!
  $ordered: Int!
) {
  recipeStepUpdate(input: {id: $id, ordered: $ordered}) {
    recipeStep {
      id
      description
      ordered
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ordered",
    "type": "Int!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
          },
          {
            "kind": "Variable",
            "name": "ordered",
            "variableName": "ordered"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "RecipeStepUpdatePayload",
    "kind": "LinkedField",
    "name": "recipeStepUpdate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "RecipeStepNode",
        "kind": "LinkedField",
        "name": "recipeStep",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "ordered",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StepsListUpdateStepMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StepsListUpdateStepMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "StepsListUpdateStepMutation",
    "operationKind": "mutation",
    "text": "mutation StepsListUpdateStepMutation(\n  $id: ID!\n  $ordered: Int!\n) {\n  recipeStepUpdate(input: {id: $id, ordered: $ordered}) {\n    recipeStep {\n      id\n      description\n      ordered\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'c0b5a4caf49c975ead967ab26bf5d4d4';

module.exports = node;
